var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 14,
    viewBox: "0 0 77 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switch-/-Large-/-2.-Casino",
    transform: "translate(-116 -6)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3_PSCasinoLogo_Neg_RGB",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M0 6.586c0 3.889 2.502 6.81 7.414 6.81 1.84 0 2.76-.186 4.029-.484v-2.79c-1.122.297-2.613.465-3.808.465-2.318 0-4.305-1.284-4.305-3.945 0-2.66 2.06-3.87 4.452-3.87 1.03 0 2.355.13 3.66.502V.41C10.377.13 9.218 0 7.617 0 3.477 0 0 2.493 0 6.586zm24.453 6.624h3.367L22.54.186h-4.378l-5.28 13.024h3.366l1.03-2.698h6.145l1.03 2.698zm-6.2-5.247l2.098-5.47 2.097 5.47h-4.195zm10.718-3.647c0 2.289 1.563 3.424 4.102 3.554l2.043.112c1.177.056 2.023.409 2.023 1.228 0 .986-.883 1.47-2.852 1.47-1.729 0-3.385-.223-4.893-.54v2.791c1.343.28 3.385.465 4.802.465 3.164 0 5.942-1.042 5.942-4.354 0-2.474-1.509-3.665-4.066-3.814l-2.465-.149c-1.16-.074-1.674-.428-1.656-1.21.018-.78.938-1.264 2.465-1.264 1.693 0 3.165.186 4.857.576V.465C37.985.167 36.385 0 34.637 0c-3.164 0-5.666 1.302-5.666 4.316zm13.012 8.894h3.11V.186h-3.11V13.21zM57.093.186v8.689L51.206.185h-3.532V13.21h2.907V4.428l5.997 8.782h3.404V.186h-2.889zM69.356 0c-3.937 0-7.12 2.251-7.12 6.735 0 4.41 3.183 6.66 7.12 6.66 3.937 0 7.12-2.25 7.12-6.66 0-4.484-3.183-6.735-7.12-6.735zm0 10.791c-2.134 0-3.808-1.377-3.808-4.056 0-2.753 1.674-4.112 3.808-4.112 2.134-.018 3.808 1.34 3.808 4.112 0 2.698-1.674 4.075-3.808 4.056z",
    id: "Fill-15"
  }))))))));
}
SvgCasino.displayName = 'Casino';
export default SvgCasino;